export default "__VITE_ASSET__ChJE0IZA__"